module.exports = __webpack_public_path__ + "img/Bots-icon.6e2085dd.svg";